import { z } from "zod";

export const actorTypeEnum = z.enum([
  "twin",
  "generated",
  "captions_ingest",
  "uploaded",
  "prompt",
  "stock",
]);
export type ActorEnumType = z.infer<typeof actorTypeEnum>;
export const actorVisibilityEnum = z.enum(["public", "private"]);

export const actorItemSchema = z.object({
  id: z.string(),
  thumbnailUrl: z.string(),
  type: actorTypeEnum,
  promptGenerationParams: z
    .object({
      characterPrompt: z.string(),
      backgroundPrompt: z.string(),
    })
    .optional()
    .nullable(),
  metadata: z.object({
    saved: z.boolean().default(false),
    visibility: actorVisibilityEnum.default("public"),
    gender: z.string().nullable(),
    rank: z.number().default(0),
  }),
});
export type ActorItemType = z.infer<typeof actorItemSchema>;

export const listActorsResponseSchema = z.object({
  actors: z.object({
    page: z.array(actorItemSchema),
    pageInfo: z.object({
      hasPrevPage: z.boolean(),
      hasNextPage: z.boolean(),
      startCursor: z.string().nullable(),
      endCursor: z.string().nullable(),
    }),
  }),
});
export type ListActorsResponseType = z.infer<typeof listActorsResponseSchema>;

export const listActorsRequestSchema = z.object({
  afterCursor: z.string().nullable().optional().default(null),
  pageSize: z.number().max(20).optional().default(10),
  filters: z
    .object({
      gender: z.string().optional(),
      type: actorTypeEnum.optional(),
      types: z.array(actorTypeEnum).optional(),
    })
    .optional(),
});
export type ListActorsRequestType = z.infer<typeof listActorsRequestSchema>;
